/* PATIRTI — indirimli fiyat duzeltmesi
   theme.js icindeki update() fonksiyonu sayfa yuklenirken
   [data-product-price] alanini sadece guncel fiyatla eziyor ve
   price.liquid'in urettigi ustu cizili karsilastirma fiyatini siliyor.
   Bu dosya theme.js'ten SONRA calisir ve dogru isaretlemeyi geri yazar. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var s = (window.theme && window.theme.settings) || {};
    // moneyFormatActive aktif pazarin formati; moneyFormat her zaman EUR verir
    var fmt = s.moneyFormatActive || s.moneyFormat || '€{{amount_with_comma_separator}}';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    var withDot = amount;
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withComma.split(',')[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withDot.split('.')[0])
      .replace(/\{\{\s*amount\s*\}\}/g, withDot);
  }

  function currentVariant(form) {
    var raw = form.getAttribute('data-variants');
    if (!raw) return null;
    var variants;
    try { variants = JSON.parse(raw); } catch (e) { return null; }
    if (!variants || !variants.length) return null;

    var chosen = {};
    Array.prototype.forEach.call(form.querySelectorAll('[data-option-index]'), function (el) {
      if (el.type === 'radio' && !el.checked) return;
      chosen[el.getAttribute('data-option-index')] = el.value;
    });

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var k in chosen) {
        if (Object.prototype.hasOwnProperty.call(chosen, k) && v.options[k] !== chosen[k]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }
    if (match) return match;

    var idField = form.querySelector('[name="id"]');
    if (idField) {
      for (var j = 0; j < variants.length; j++) {
        if (String(variants[j].id) === String(idField.value)) return variants[j];
      }
    }
    for (var n = 0; n < variants.length; n++) {
      if (variants[n].available) return variants[n];
    }
    return variants[0];
  }

  function paint(form) {
    var scope = form.closest('.product__details') || form.closest('.quickview__body') || form.closest('.quickview') || form;
    var priceEl = scope.querySelector('[data-product-price]');
    if (!priceEl) return;

    var v = currentVariant(form);
    if (!v) return;

    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    // Sira price.liquid ile ayni: guncel fiyat, ustu cizili eski fiyat, yuzde rozeti
    var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    var html = onSale
      ? '<span class="price price--on-sale">' +
          '<span class="price__sale">' + formatMoney(v.price) + '</span>' +
          '<span class="price__regular">' + formatMoney(v.compare_at_price) + '</span>' +
          (pct > 0 ? '<span class="price__badge">-' + pct + '%</span>' : '') +
        '</span>'
      : '<span class="price">' +
          '<span class="price__current">' + formatMoney(v.price) + '</span>' +
        '</span>';

    if (priceEl.innerHTML !== html) priceEl.innerHTML = html;
  }

  function bind(form) {
    if (form.getAttribute('data-sale-fix') === '1') { paint(form); return; }
    form.setAttribute('data-sale-fix', '1');
    form.addEventListener('change', function () {
      window.setTimeout(function () { paint(form); }, 0);
    });
    paint(form);
  }

  function run() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-form]'), bind);
  }

  function boot() {
    run();
    window.setTimeout(run, 300);

    var qv = document.getElementById('quickview-content');
    if (qv && window.MutationObserver) {
      new MutationObserver(function () {
        window.setTimeout(run, 0);
      }).observe(qv, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
